import { HandlerType, datadogLogs } from '@datadog/browser-logs';
import type { LogsEvent } from '@datadog/browser-logs';

import { scrubEmails } from 'utils/pii';

/**
 * safely extracts a readable error message from any error type.
 * handles Error objects, plain objects with a message property
 * (e.g. Cognito SDK errors), strings, and unknown values.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String((error as { message: unknown }).message);
  }

  return String(error);
}

export function initDatadogLogs(): void {
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;

  if (clientToken) {
    datadogLogs.init({
      clientToken,
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      env: process.env.REACT_APP_RBI_ENV,
      service: 'th-guest-support-tool',
      version: process.env.REACT_APP_COMMIT_REF,
      beforeSend: (event: LogsEvent) => {
        event.message = scrubEmails(event.message);
        if (event.view?.url) {
          event.view.url = scrubEmails(event.view.url);
        }
        if (event.view?.referrer) {
          event.view.referrer = scrubEmails(event.view.referrer);
        }
        if (event.error?.stack) {
          event.error.stack = scrubEmails(event.error.stack);
        }
        if (event.http?.url) {
          event.http.url = scrubEmails(event.http.url);
        }
        return true;
      },
    });

    datadogLogs.logger.setHandler(HandlerType.http);
  }
}
